import type { RouteObject } from 'react-router-dom'
import Debug from 'debug'

import { WithAuth } from '@jotta/grpc-connect-client/WithAuth'
import { queryClient } from '@jotta/query'

import { PrivateLayout } from '../components/Layout/PrivateLayout'

import { BizLayout } from './layout/BizLayout'
import { BizDashboardRoute } from './routes/BizDashboardRoute'
import { BizSettingsRoute } from './routes/BizSettingsRoute'
import { BizUserCreateRoute } from './routes/BizUserCreateRoute'
import { BizUserEditRoute } from './routes/BizUserEditRoute'
import { BizUsersRoute } from './routes/BizUsersRoute'
import { bizApi } from './BizApi'
import { BizBillingHistoryRoute } from './routes/BizBillingHistoryRoute'
import { BizOrderReceiptRoute } from './routes/BizOrderReceiptRoute'

const debug = Debug('jotta:biz:routes')

export const bizRoutes: RouteObject = {
  path: '/biz',
  element: (
    <WithAuth>
      <PrivateLayout />
    </WithAuth>
  ),
  children: [
    {
      element: <BizLayout />,
      children: [
        {
          index: true,
          element: <BizDashboardRoute />,
        },
        {
          path: 'users',
          children: [
            {
              index: true,
              element: <BizUsersRoute />,
            },
            {
              path: 'create',
              element: <BizUserCreateRoute />,
            },
            {
              path: ':username',
              loader: async ({ params }) => {
                const user = await queryClient.fetchQuery(
                  bizApi.user.byId.getFetchOptions({
                    username: params.username || '',
                  }),
                )
                return user
              },
              element: <BizUserEditRoute />,
            },
          ],
        },

        {
          path: 'settings',
          children: [
            {
              index: true,
              element: <BizSettingsRoute />,
            },
            {
              path: 'billingHistory',
              children: [
                {
                  index: true,
                  element: <BizBillingHistoryRoute />,
                },
                {
                  path: ':orderNumber',
                  element: <BizOrderReceiptRoute />,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
}
